import React from 'react'
import { useHistory, useRouteMatch } from 'react-router'

import { AsideSection } from '../AsideSection'
import { MedicamentosCard } from './MedicamentosCard'

export interface MedicamentosSectionProps {
  prontuarioId: ID
  dataAtendimento: Instant
}

export function MedicamentosSection(props: MedicamentosSectionProps) {
  const { prontuarioId, dataAtendimento } = props

  const history = useHistory()
  const match = useRouteMatch()

  const handleClick = () =>
    history.push({
      pathname: `${match.url}/medicamentos-ativos-concluidos`,
      state: {
        prontuarioId: prontuarioId,
        dataAtendimento: dataAtendimento,
      },
    })

  return (
    <AsideSection title='Medicamentos em uso' onClick={handleClick}>
      <MedicamentosCard {...props} />
    </AsideSection>
  )
}
